/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { motion } from "framer-motion"
import * as React from "react"
import { twMerge } from "tw-merge"

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function ProgressBar(props) {
  return (
    <div
      className={twMerge(
        `bg-[#EEEEEE] rounded-[12px] max-w-[328px] w-full  ${
          props.classes?.componentContainer
            ? props.classes.componentContainer
            : ""
        }`,
      )}
    >
      <motion.div
        className={twMerge(
          `bg-atlantic-blue h-[6px] transition-all ${
            props.classes?.progressContainer
              ? props.classes.progressContainer
              : ""
          }`,
        )}
        style={{
          scaleX: props.currentStep / props.totalSteps,
          transformOrigin: "0",
        }}
      ></motion.div>
    </div>
  )
}
